import generateBlogPostingSchemaOrgData from 'src/helpers/generateBlogPostingSchemaOrgData';
import generateSchemaOrgCommonValues from 'src/helpers/generateSchemaOrgCommonValues';
import { computed } from 'vue';
import { useRenderStore } from 'stores/render';

export default () => {
  const renderStore = useRenderStore();
  const defaultPostFields = computed(() => generateBlogPostingSchemaOrgData(renderStore.post));
  const {
    publicHostUrl,
    logo,
    context,
    name,
  } = generateSchemaOrgCommonValues(renderStore.settings);

  return computed(() => ({
      '@context': context,
      ...defaultPostFields.value,
      publisher: {
        '@type': 'Organization',
        '@id': publicHostUrl,
        name,
        logo,
      },
      isPartOf: {
        '@type': 'Blog',
        '@id': publicHostUrl,
        name,
        publisher: {
          '@type': 'Organization',
          '@id': publicHostUrl,
          name,
        },
      },
      wordCount: renderStore.post.wordsCount,
    }));
};
